module.exports = __webpack_public_path__ + "static/NFT-icon-719011312ae0ca34373f82e313a50a40.webp";